import { isToday } from '@internationalized/date';
import clsx from 'clsx';
import { useContext, useEffect } from 'react';
import {
  CalendarCell as RACCalendarCell,
  CalendarGrid as RACCalendarGrid,
  CalendarGridBody as RACCalendarGridBody,
  CalendarGridHeader as RACCalendarGridHeader,
  CalendarHeaderCell as RACCalendarHeaderCell,
  CalendarStateContext as RACCalendarStateContext,
  HeadingContext as RACHeadingContext,
} from 'react-aria-components';
import { useLocalizedMessages } from '../../../../i18n/index.js';
import { IconChevronLeft, IconChevronRight } from '../../../../icons/index.js';
import { Button } from '../../../button/button.js';
import { IconButton } from '../../../button/icon-button.js';
import { textStyle } from '../../../typography/utils.js';
import { useDatePickerView } from './../view-provider.js';

/** @internal */
export function MonthView() {
  const state = useContext(RACCalendarStateContext);
  const {
    // @ts-expect-error RACHeadingContext contains a `children` property, but it's not in the types
    children: title,
  } = useContext(RACHeadingContext);
  const { switchToView } = useDatePickerView();
  const messages = useLocalizedMessages('datePicker');

  useEffect(() => {
    state?.setFocused(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="cim-date-picker-view-header">
        <IconButton
          slot="previous"
          aria-label={messages.format('previousMonth')}
          icon={<IconChevronLeft />}
          variant="tertiary"
          size="small"
        />

        <Button
          slot={null}
          aria-label={messages.format('switchToYearView')}
          variant="tertiary"
          onPress={() => switchToView('year')}
        >
          {title}
        </Button>

        <IconButton
          slot="next"
          aria-label={messages.format('nextMonth')}
          icon={<IconChevronRight />}
          variant="tertiary"
          size="small"
        />
      </div>

      <RACCalendarGrid className="cim-date-picker-view-grid" weekdayStyle="narrow">
        <RACCalendarGridHeader>
          {(day) => (
            <RACCalendarHeaderCell>
              <div
                className={clsx(
                  'cim-date-picker-calendar-header-cell',
                  textStyle({ variant: 'medium-semibold', tone: 'base' }),
                )}
              >
                {day}
              </div>
            </RACCalendarHeaderCell>
          )}
        </RACCalendarGridHeader>
        <RACCalendarGridBody>
          {(date) => {
            const isCurrentDate = isToday(date, state!.timeZone);

            return (
              <RACCalendarCell
                className={clsx(
                  'cim-date-picker-calendar-cell',
                  textStyle({ variant: isCurrentDate ? 'medium-semibold' : 'medium' }),
                )}
                date={date}
                data-current={isCurrentDate || undefined}
              />
            );
          }}
        </RACCalendarGridBody>
      </RACCalendarGrid>
    </>
  );
}
